<template>
  <!--  面对面邀请二维码-->
  <div class="invitation">
    <div class="qr-code-div">
      <div class="bg-up">
        <img src="../../assets/images/coins/share_top.png" style="">

        <div class="qr-code-content">
          <div class="qr-code-content-bd" style="">

            <div class="qr-code-template" ref="qrCodeUrl" style="display: none">
            </div>
            <div class="qr-code">
              <img :src="img" style="">

            </div>
            <div class="qr-code-text">免费下载 快速找工作</div>
            <div>
              <img style="width: 60%; margin-left: 20%" src="../../assets/images/coins/share_tip.png">
            </div>

          </div>
          <div class="bottom-download">
            <van-button round color="#FFB111FF" @click.stop="onScreenshot" block>下载我的推广码
            </van-button>
          </div>
        </div>
      </div>
    </div>

    <van-overlay :show="overlayShow" @click="overlayShow = false" :z-index="999">
      <div>
        <img class="share-img" src="../../assets/images/coins/share.png">
      </div>
    </van-overlay>

  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { getWxXcxQrCode } from '@api/home'
import Vue from 'vue'

export default {
  name: 'invitation',
  data () {
    return {
      overlayShow: false,
      isApp: true,
      img: ''
    }
  },

  mounted () {
    // 通过ua标识判断
    var userAgent = navigator.userAgent.toLowerCase()//获取UA信息

    // 不在app内
    if (userAgent.indexOf('yaogong') == -1) {//判断ua中是否含有和app端约定好的标识yaogong
      this.isApp = false
    }

    this.refereesPhone = this.$route.query.refereesPhone

    this.creatQrCode()

  },
  methods: {

    // 下载图片
    onScreenshot () {
      this.$bridge.callHandler('screenshot', response => {
        console.log('response:', response)
      })
    },

    // 生成二维码
    creatQrCode () {
      getWxXcxQrCode().then(res => {
        if (res.data.code === 200) {
          this.img = 'data:image/png;base64,' + res.data.data
          /*let url = res.data.data + this.refereesPhone
          var qrcode = new QRCode(this.$refs.qrCodeUrl, {
            text: url, // 需要转换为二维码的内容
            width: 400,
            height: 400,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })

          // 延时渲染二维码
          setTimeout(() => {
            //获取canvas：
            var canvas = document.querySelector('canvas')
            //将canvas转码：
            var base64Text = canvas.toDataURL('image/png')
            this.img = base64Text
          }, 100)*/
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">

.invitation {
  background-color: #FFFFFFFF;
  background-position: top;
  background-size: cover;
  background-image: url('../../assets/images/coins/share_bg.png');
  width: 100%;
  position: relative;
}

canvas {
  display: inline !important;
}

.qr-code-div {
  min-height: 100vh;
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('../../assets/images/coins/share_ft.png');
  width: 100%;

  .qr-code-content {
    position: absolute;
    top: 35%;
    left: 20%;
    width: 60%;
    margin: auto;
    text-align: center;
    font-size: 18px;
    padding-top: 5px;
    padding-bottom: 10px;

    .qr-code-content-bd {
      border-radius: 18px 18px 18px 18px;
      background-color: #FFFFFF;
      width: 100%;
      margin: auto;
      text-align: center;
      font-size: 18px;
      padding-top: 5px;
      padding-bottom: 10px;
    }

    .qr-code {
      text-align: center;
      width: 100%;
      min-height: 200px;
      margin: auto;
      padding: 15px 15px 10px 15px;
    }

    .qr-code-text {
      padding: 0 8px;
      padding-bottom: 5px;
    }

  }
}

.bottom-download {
  padding-top: 10px;

  .van-button {
    font-size: 18px;
  }
}

</style>
